module.exports = __webpack_public_path__ + "img/slowmist1.2ddce0a3.png";